import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumGermanBeerDutyProductType implements BaseEnumType {
  private static allValues: EnumGermanBeerDutyProductType[] = []; // make sure this is top-most
  
  public static none = new EnumGermanBeerDutyProductType(0, "None", "enum_german_beer_duty_product_type_none");
  public static ownBrewedBeer_E = new EnumGermanBeerDutyProductType(1, "OwnBrewedBeer_E", "enum_german_beer_duty_product_type_own_brewed_beer__e");
  public static brewedByUsFor3rdParty_L = new EnumGermanBeerDutyProductType(2, "BrewedByUsFor3rdParty_L", "enum_german_beer_duty_product_type_brewed_by_us_for3rd_party__l");
  public static brewedBy3rdPartyForUs_F = new EnumGermanBeerDutyProductType(3, "BrewedBy3rdPartyForUs_F", "enum_german_beer_duty_product_type_brewed_by3rd_party_for_us__f");
  public static mixedProduct_M = new EnumGermanBeerDutyProductType(4, "MixedProduct_M", "enum_german_beer_duty_product_type_mixed_product__m");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumGermanBeerDutyProductType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumGermanBeerDutyProductType.none; }
  public isOwnBrewedBeer_E() { return this === EnumGermanBeerDutyProductType.ownBrewedBeer_E; }
  public isBrewedByUsFor3rdParty_L() { return this === EnumGermanBeerDutyProductType.brewedByUsFor3rdParty_L; }
  public isBrewedBy3rdPartyForUs_F() { return this === EnumGermanBeerDutyProductType.brewedBy3rdPartyForUs_F; }
  public isMixedProduct_M() { return this === EnumGermanBeerDutyProductType.mixedProduct_M; }

  public static getValues(): readonly EnumGermanBeerDutyProductType[] {
    return EnumGermanBeerDutyProductType.allValues;
  }

  public static getValuesExcept0(): readonly EnumGermanBeerDutyProductType[] {
    return EnumGermanBeerDutyProductType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumGermanBeerDutyProductType {
    const found = EnumGermanBeerDutyProductType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumGermanBeerDutyProductType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumGermanBeerDutyProductType): EnumGermanBeerDutyProductType {
    const found = name ? EnumGermanBeerDutyProductType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumGermanBeerDutyProductType - Value not found: ${ name }`);
    }

    return found;
  }
}